import React from 'react';
import { Link } from 'react-router-dom';

const SuperBowlDetailsPage: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <h1 className="text-center mb-3">Super Bowl LX Outreach 2026</h1>
          <p className="text-center text-muted mb-4">Santa Clara, California • February 6-8, 2026</p>

          <div className="alert alert-info text-center mb-4">
            <strong>Hosted by Unity Missionary Baptist Church of Sunnyvale, CA</strong>
            <br />
            Join us for this great outreach opportunity in the San Francisco Bay Area!
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Event Schedule</h4>
              <ul>
                <li><strong>Friday, February 6:</strong> Meet & Greet and dinner at Unity Missionary Baptist Church at 6 PM</li>
                <li><strong>Saturday, February 7:</strong> Breakfast at the Church with orientation at 8 AM, then to the Super Bowl Experience area to pass out scripture and witness</li>
                <li><strong>Sunday, February 8:</strong> Morning services, then outreach will be around Levi Stadium</li>
              </ul>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Registration Options</h4>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="border rounded p-3 h-100">
                    <h5>Entire Outreach</h5>
                    <p className="fs-4 fw-bold text-primary">$75</p>
                    <small>Saturday & Sunday</small>
                    <ul className="mt-2 small">
                      <li>T-shirt</li>
                      <li>Transportation to venue each day</li>
                      <li>Continental breakfast and dinner on Saturday</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="border rounded p-3 h-100">
                    <h5>Saturday Only</h5>
                    <p className="fs-4 fw-bold text-primary">$45</p>
                    <small>Saturday Outreach</small>
                    <ul className="mt-2 small">
                      <li>T-shirt</li>
                      <li>Transportation to venue</li>
                      <li>Continental breakfast and dinner</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="border rounded p-3 h-100">
                    <h5>Sunday Only</h5>
                    <p className="fs-4 fw-bold text-primary">$40</p>
                    <small>Sunday Outreach</small>
                    <ul className="mt-2 small">
                      <li>T-shirt</li>
                      <li>Transportation to venue</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="alert alert-warning mt-3">
                <strong>Lodging:</strong> Arrangements available for $80 per person per night (double occupancy). Hotel space is limited - contact Ron ASAP if you need a room.
              </div>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Contact Information</h4>
              <p><strong>Ron Ludikhuize</strong><br />
              Phone: <a href="tel:909-730-9288">909-730-9288</a><br />
              Email: <a href="mailto:westcoastOBP@gmail.com">westcoastOBP@gmail.com</a> or <a href="mailto:RJLudikhuize@gmail.com">RJLudikhuize@gmail.com</a></p>

              <p><strong>Pastor Matt Wise</strong><br />
              Phone: <a href="tel:408-506-4053">408-506-4053</a></p>

              <p className="text-danger mb-0"><strong>Important:</strong> Please contact Ron prior to making any flight reservations!</p>
            </div>
          </div>

          <div className="text-center mb-4">
            <Link to="/events/super-bowl-2026/apply" className="btn btn-success btn-lg me-3">
              <i className="fas fa-clipboard-check me-2" aria-hidden></i>
              Register / Apply
            </Link>
            <a href="/docs/Super Bowl 2026 Flyer.doc" className="btn btn-outline-secondary btn-lg" download>
              <i className="fas fa-download me-2" aria-hidden></i>
              Download Flyer
            </a>
          </div>

          <div className="card">
            <div className="card-body">
              <h5>Additional Resources</h5>
              <ul>
                <li>For more information and to register, visit <a href="https://WestCoastOBP.com" target="_blank" rel="noopener noreferrer">WestCoastOBP.com</a> or <a href="https://theOBP.com">theOBP.com</a></li>
                <li>See the Super Bowl Outreach on Facebook</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperBowlDetailsPage;
